import { render, staticRenderFns } from "./AssessmentError.vue?vue&type=template&id=1d53e96a&scoped=true"
import script from "./AssessmentError.vue?vue&type=script&lang=ts"
export * from "./AssessmentError.vue?vue&type=script&lang=ts"
import style0 from "./AssessmentError.vue?vue&type=style&index=0&id=1d53e96a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d53e96a",
  null
  
)

export default component.exports